export const NewReservationAction = () => ({
  label: "New Reservation",
  icon: "add-reservation",
  href: (row) => row.newReservationPath,
})

export const NewContractAction = ({ onClickSingle }) => ({
  label: "New Contract",
  icon: "add-contract",
  onClickSingle,
})

export const ArchiveContactBoatAction = ({ onClickSingle }) => ({
  label: "Archive",
  icon: "archive",
  danger: true,
  onClickSingle,
  confirm: {
    title: "Archive boat",
    message: (row) => `Are you sure you want to archive ${row.name}?`,
    confirmLabel: "Archive",
  },
})

export const RestoreContactBoatAction = ({ onClickSingle }) => ({
  label: "Restore",
  icon: "replay",
  onClickSingle,
  disabled: (row) => row.contactArchived,
})
